import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'title',
      type: 'input',
      label: '标题',
      placeholder: '请输入标题',
      rules: { required: true, message: '标题是必传的', trigger: 'blur' }
    },
    {
      field: 'content',
      type: 'textarea',
      label: '内容',
      placeholder: '请选择内容',
      rules: { required: true, message: '内容是必传的', trigger: 'blur' }
    },
  ],
  colLayout: 24,
  itemStyle: {}
}
